import React from 'react';
import { useNavigate } from 'react-router-dom';
import { emptyECMR, saveECMR } from '../services/eCMRService';
import { ECMR } from '../types/eCMR';
import ECMRForm from './ECMRForm';

const CreateECMR: React.FC = () => {
  const navigate = useNavigate();
  
  const handleSubmit = (data: ECMR) => {
    try {
      // Asignar fecha actual si no existe
      if (!data.ExchangedDocument?.IssueDateTime?.DateTimeString) {
        const now = new Date();
        const formattedDateTime = now.toISOString().replace(/[-:]/g, '').substring(0, 14);
        
        data.ExchangedDocument = {
          ...data.ExchangedDocument,
          IssueDateTime: {
            DateTimeString: formattedDateTime
          }
        };
      }
      
      // Crear ID automático si no existe
      if (!data.ExchangedDocument?.ID) {
        data.ExchangedDocument = {
          ...data.ExchangedDocument,
          ID: `CMR-${Math.floor(Math.random() * 1000000).toString().padStart(6, '0')}`
        };
      }
      
      const key = saveECMR(data);
      navigate(`/view/${key}`);
    } catch (error) {
      console.error('Error al guardar el e-CMR:', error);
      alert('Error al guardar el e-CMR');
    }
  };
  
  const handleCancel = () => {
    navigate('/');
  };
  
  return (
    <div className="container mx-auto p-4">
      <h1 className="text-2xl font-bold mb-6">Crear Nuevo e-CMR</h1>
      <ECMRForm
        initialData={emptyECMR}
        onSubmit={handleSubmit}
        onCancel={handleCancel}
      />
    </div>
  );
};

export default CreateECMR;

 